import {MI} from "../init";
import {he, wi} from "../../framework/src/engine/madnes/madnes_variables";
import {ReelMotion} from "./ReelMotion";
import {SpinReel} from "./SpinReel";
import {copyArray} from "../../framework/src/helpers";
import {ReelsEngine} from "./ReelsEngine";
import ReelManager from "./ReelManager";
/**
 * @constructor
 * @returns {SpinReels}
 */
export default function SpinReels() {

    /** @type {GameConfig}  */
    this._gameConfig;

    /** @type {ServerConfig} */
    this._serverConfig;

    /** @type {Array} */
    this._serverReels;

    /** @type {SymbolsManager} */
    this.symbolsManager;

    /** @type Array<ReelManager> */
    this._reels = [];

    /** @type {ReelsEngine} */
    this._engine;
};

/**
 * @param {GameConfig} gameConfig
 * @param {ServerConfig} serverConfig
 * @param {SymbolsManager} symbolsManager
 * @param {GameGroups} gameGroups
 * @returns {undefined}
 */
SpinReels.prototype.init = function(gameConfig, serverConfig, symbolsManager, gameGroups) {
    this._gameConfig = gameConfig;
    this._serverConfig = serverConfig;
    this._symbolsManager = symbolsManager;
    this._groups = gameGroups;
};

/** @param {Array} sReels */
SpinReels.prototype.setServerReels = function(sReels) {
    this._serverReels = sReels;
};

SpinReels.prototype.getServerReels = function() {
    return this._serverReels;
};

SpinReels.prototype.createReels = function() {
    var _self = this;

    var reelsCount = this._serverReels.length;

    for(var i = 0; i < reelsCount; i++) {

        var reel = new ReelManager();

        reel.init(this._gameConfig, this._serverConfig, this._symbolsManager, this._groups);
        reel.create(i);
        this._reels[i] = reel;
    }

    this._engine = new ReelsEngine();
    this._engine.onLoop(function(delta) {

        for(var i = 0; i < reelsCount; i++) {
            _self._reels[i].getMotion().tick(delta);
        }

    });

    this.printReels();
};

SpinReels.prototype.prepareSymbolsForSpin = function() {

    for(var i = 0; i < this._reels.length; i++) {
        var reel = this.getReel(i);
        var symbols = reel.getSymbols();

        for(var j = 0; j < symbols.length; j++) {
            symbols[j].revive();
            symbols[j].setVisible(true);
        }
    }
};

SpinReels.prototype.startSpinReels = function () {
    this._engine.start();
};

SpinReels.prototype.stopSpinReels = function () {
    this._engine.stop();
};

/** @param {Array} reelMatrix */
SpinReels.prototype.prepareResult = function(reelMatrix) {
    this.setResult(reelMatrix);
    this.makeResSymbols();
    this.setMotionResult();
};

/**
 * @param {Array} reelMatrix
 * @param {boolean=} force
 */
SpinReels.prototype.setResult = function(reelMatrix, force) {

    for(var i = 0; i < this._reels.length; i++) {
        if(!force && !this._reels[i].hasStarted()) {
            console.warn("reel " + this._reels[i].getReel() + " not spinning - cannot set result matrix");
            continue;
        }

        this._reels[i].getReel().setReelMatrix(reelMatrix[i]);
        this._reels[i].initResSymbols(this._groups.get("group_symbols_" + i));
    }
};

SpinReels.prototype.setMotionResult = function() {

    for(var i = 0; i < this._reels.length; i++) {
        if(!this._reels[i].hasStarted()) {
            console.warn("reel " + this._reels[i].getReel().id + " not spinning - cannot set result");
            continue;
        }

        this._reels[i].setResultSymbols();
    }
};

SpinReels.prototype.makeResSymbols = function() {
    for(var i = 0; i < this._reels.length; i++) {

        if(!this._reels[i].hasStarted()) {
            console.warn("reel " + this._reels[i].getReel().id + " not spinning - cannot set blur symbol");
            continue;
        }

        var reel = this._reels[i].getReel();

        this._symbolsManager.blurSymbols(reel.getResSymbols());
        this._symbolsManager.addToGroup(reel.getResSymbols(), this._groups.get("group_symbols_" + i));
    }
};

SpinReels.prototype.printReels = function() {
    for(var i = 0; i < this._reels.length; i++) {
        this._reels[i].print();
    }
};

/** @returns {Array<ReelManager>} */
SpinReels.prototype.getReelsManagers = function() {
    return this._reels;
};

/**
 * @param {number} id
 * @returns {ReelManager}
 */
SpinReels.prototype.getReelManager = function(id) {
    return this._reels[id];
};

/**
 * @param {number} id
 * @returns {SpinReel}
 */
SpinReels.prototype.getReel = function(id) {
    return this._reels[id].getReel();
};

SpinReels.prototype.getResSymbol = function(x, y) {
    return this.getReel(x).getResSymbols()[y];
};

/**
 * @param {Array} positions
 * @returns {Array<AbstractSymbol>}
 */
SpinReels.prototype.getResSymbols = function(positions) {
    var symbols = [];

    for(var i = 0; i < positions.length; i++) {
        var x = positions[i][0];
        var y = positions[i][1];

        symbols.push(this.getResSymbol(x, y));
    }

    return symbols;
};

/** @returns {Array<MadnesObject>} */
SpinReels.prototype.getAllResSymbols = function() {
    var symbols = [];

    for(var i = 0; i < this._reels.length; i++) {
        symbols.push.apply(symbols, this._reels[i].getReel().getResSymbols());
    }

    return symbols;
};

///** @returns {Array<AbstractSymbol>} */
//SpinReels.prototype.getAllSpreadedSymbols = function() {
//
//	var symbols = this.getAllresSymbols();
//	var symbs = [];
//
//	for(var i = 0; i < symbols.length; i++) {
//		if(symbols[i].spreaded) {
//			symbs.push(symbols[i]);
//		}
//	}
//
//	return symbs;
//};

///**
// * @param {number} id
// * @returns {AbstractSymbol|null}
// */
//SpinReels.prototype.getSpreadedFromReel = function(id) {
//
//	var symbols = this.getReel(id).resSymbols;
//
//	for(var i = 0; i < symbols.length; i++) {
//		if(symbols[i].spreaded) {
//			return symbols[i];
//		}
//	}
//
//	return null;
//};

///** @param {Array<AbstractSymbol>} spreadSymbols */
//SpinReels.prototype.setSpreaded = function(spreadSymbols) {
//	for(var i = 0; i < spreadSymbols.length; i++) {
//		var reelX = spreadSymbols[i].reelPos['x'];
//		this.getReel(reelX).spreaded = true;
//	}
//};

///**
// * @param {AbstractSymbol} symbol
// * @returns {boolean}
// */
//SpinReels.prototype.isInSpread = function(symbol) {
//	var reelX = symbol.getReelX();
//	return this.getReel(reelX).spreaded;
//
//};

//SpinReels.prototype.reinitSpreaded = function() {
//	for(var i = 0; i < this._reels.length; i++) {
//		this.getReel(i).spreaded = false;
//	}
//};

//SpinReels.prototype.destroy = function() {
//
//	this._engine && this._engine.destroy();
//	this._engine = null;
//
//	for(var i = 0; i < this.reels.length; i++) {
//		this.reels[i].destroy();
//	}
//	this.reels.length = 0;
//};